import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const createLead = (payload) => api.post("/leads", payload).then((r) => r.data);
export const createPlanCheckout = (payload) =>
  api.post("/checkout/plan", payload).then((r) => r.data);
export const createCareCheckout = (payload) =>
  api.post("/checkout/care", payload).then((r) => r.data);
export const createPromoCheckout = (payload) =>
  api.post("/checkout/promo", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export const adminLogin = async (password) => {
  // Fetch leads as auth probe
  await api.post("/admin/leads", { password });
  return true;
};
export const adminFetchLeads = (password) =>
  api.post("/admin/leads", { password }).then((r) => r.data);
export const adminFetchStats = (password) =>
  api.post("/admin/stats", { password }).then((r) => r.data);
export const adminFetchPayments = (password) =>
  api.post("/admin/payments", { password }).then((r) => r.data);

// Projects
export const fetchProjectByToken = (token) =>
  api.get(`/projects/track/${token}`).then((r) => r.data);
export const adminFetchProjects = (password) =>
  api.post("/admin/projects", { password }).then((r) => r.data);
export const adminCreateProject = (payload) =>
  api.post("/admin/projects/create", payload).then((r) => r.data);
export const adminUpdateProject = (payload) =>
  api.post("/admin/projects/update", payload).then((r) => r.data);

export const adminChangePassword = (current_password, new_password) =>
  api
    .post("/admin/change-password", { current_password, new_password })
    .then((r) => r.data);
